export default __webpack_public_path__ + "static/media/profile.f43f1086.svg";